module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Regular.a5a368a.ttf";